// src/pages/dashboard/Dashboard.jsx
import React from 'react';
import '@assets/css/dashboard/style_dashboard.css'

function Dashboard() {
  return (
    <>
    
        {/*대시보드 콘텐츠 시작*/}
        <div className="page-title-container">
            <h1 className="page-title">대시보드</h1>
        </div>

        <div className="dashboard-stats">
            <div className="stat-card">
                <h4>총 방문자</h4>
                <div className="stat-value">12,345</div>
                <div className="stat-change positive">+12.5%</div>
            </div>

            <div className="stat-card">
                <h4>총 페이지뷰</h4>
                <div className="stat-value">45,678</div>
                <div className="stat-change positive">+8.3%</div>
            </div>

            <div className="stat-card">
                <h4>평균 체류시간</h4>
                <div className="stat-value">3분 24초</div>
                <div className="stat-change negative">-2.1%</div>
            </div>

            <div className="stat-card">
                <h4>전환율</h4>
                <div className="stat-value">5.7%</div>
                <div className="stat-change positive">+1.2%</div>
            </div>
        </div>

        <div className="dashboard-charts">
            <div className="chart-container">
                <h4>방문자 추이</h4>
                <div className="chart-placeholder">
                    <div className="chart-mock"></div>
                </div>
            </div>

            <div className="chart-container">
                <h4>페이지별 방문</h4>
                <div className="chart-placeholder">
                    <div className="chart-mock"></div>
                </div>
            </div>
        </div>

        <div className="recent-activities">
            <h4>최근 활동</h4>
            <ul className="activity-list">
                <li className="activity-item">
                    <div className="activity-time">10:23</div>
                    <div className="activity-description">새로운 방문자 유입 (모바일)</div>
                </li>
                <li className="activity-item">
                    <div className="activity-time">09:45</div>
                    <div className="activity-description">결제 완료 (#12345)</div>
                </li>
                <li className="activity-item">
                    <div className="activity-time">09:12</div>
                    <div className="activity-description">새 회원 가입</div>
                </li>
                <li className="activity-item">
                    <div className="activity-time">08:30</div>
                    <div className="activity-description">시스템 업데이트 완료</div>
                </li>
            </ul>
        </div>
        {/*대시보드 콘텐츠 끝*/}
    </>
  );
}

export default Dashboard;